import React from 'react';
import styles from './__styles__/index.scss?modules';
import { ContentPanel } from './Desktop';

const Mobile = ({ backImgUrl, title, header }) => {
  return (
    <div className={styles.mobileOuter}>
      <ContentPanel title={title} header={header} />
      <div className={styles.mobileImgHolder}>
        <img src={backImgUrl} alt="" />
      </div>
    </div>
  );
};

export default React.memo(Mobile);
